import Vue from 'vue'
import Vuex from 'vuex'
import { resolveFileUrl, resolveFileThumb } from '@/lib/fileUrl'
import App from './App.vue'

Vue.prototype.$resolveFileUrl = resolveFileUrl
Vue.prototype.$resolveFileThumb = resolveFileThumb
import router from './router'
import store from './store' // your vuex store 
import { createProvider } from './vue-apollo'

Vue.use(Vuex);

// import StarRating from 'vue-star-rating'
// Vue.component('star-rating', StarRating);

// import visibility from 'vue-visibility-change';
// Vue.use(visibility);

import BootstrapVue from 'bootstrap-vue'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
Vue.use(BootstrapVue)

import VueToast from 'vue-toast-notification';
import 'vue-toast-notification/dist/theme-default.css';
Vue.use(VueToast, {
  position: 'top-right'
});

import VuejsDialog from 'vuejs-dialog';
import 'vuejs-dialog/dist/vuejs-dialog.min.css';
Vue.use(VuejsDialog);


import 'vue-slick-carousel/dist/vue-slick-carousel-theme.css'

require('@/assets/css/font-awesome.css');
require('@/assets/css/animate.css');
require('@/assets/css/custom.css');



const moment = require('moment');
require('moment/locale/es');
Vue.use(require('vue-moment'), {moment});

// import panZoom from 'vue-panzoom'
// Vue.use(panZoom);

import VueGeolocation from 'vue-browser-geolocation';
Vue.use(VueGeolocation);


import VueProgressBar from 'vue-progressbar'
Vue.use(VueProgressBar, {
  color: '#02bcd7',
  failedColor: 'red',
  height: '2px'
})

import SimpleVueValidation from 'simple-vue-validator';
Vue.use(SimpleVueValidation, {mode: 'conservative'})

import VueSignaturePad from 'vue-signature-pad';
Vue.use(VueSignaturePad);

import Multiselect from 'vue-multiselect';
import 'vue-multiselect/dist/vue-multiselect.min.css'
Vue.component('multiselect', Multiselect)

import '../node_modules/vue-ads-pagination/dist/vue-ads-pagination.css';
import VueAdsPagination from 'vue-ads-pagination';
Vue.component('VueAdsPagination', VueAdsPagination)

import DatePicker from 'vue2-datepicker'
import 'vue2-datepicker/locale/es';
import 'vue2-datepicker/index.css'
Vue.component('DatePicker', DatePicker)

import vSelect from 'vue-select'
Vue.component('v-select', vSelect)
import 'vue-select/dist/vue-select.css';

import VueTextareaAutosize from 'vue-textarea-autosize'
Vue.use(VueTextareaAutosize)

import ToggleButton from 'vue-js-toggle-button'
Vue.use(ToggleButton)

// import VueSimpleSuggest from 'vue-simple-suggest'
// import 'vue-simple-suggest/dist/styles.css'
// Vue.component('vue-simple-suggest', VueSimpleSuggest)

// import VueDraggableResizable from 'vue-draggable-resizable'
// import 'vue-draggable-resizable/dist/VueDraggableResizable.css'
// Vue.component('vue-draggable-resizable', VueDraggableResizable)

import VueNumeric from 'vue-numeric'
Vue.use(VueNumeric)


import axios from 'axios'
import VueAxios from 'vue-axios'
const API_URL = process.env.VUE_APP_API_URL || 'http://127.0.0.1:8000';
axios.defaults.baseURL = API_URL;
axios.defaults.headers.post['Content-Type'] = 'application/json';
const token = localStorage.getItem('token');
if (token) {
  axios.defaults.headers.common['Auth'] = token;
}
Vue.use(VueAxios, axios)

Vue.config.productionTip = false

new Vue({
  router,
  store,
  apolloProvider: createProvider(),
  render: h => h(App)
}).$mount('#app')
